var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUudSns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 21.844c5.437 0 9.844-4.407 9.844-9.844 0-5.437-4.407-9.844-9.844-9.844-5.437 0-9.844 4.407-9.844 9.844 0 5.437 4.407 9.844 9.844 9.844Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUudSns);
export default __webpack_public_path__ + "static/media/uud_sns.baadeb2995f1d040ea645c5a38a3cf5d.svg";
export { ForwardRef as ReactComponent };